import { render, staticRenderFns } from "./e-organization-change.vue?vue&type=template&id=ec4b21d6&scoped=true&lang=pug"
import script from "./e-organization-change.vue?vue&type=script&lang=js"
export * from "./e-organization-change.vue?vue&type=script&lang=js"
import style0 from "./e-organization-change.vue?vue&type=style&index=0&id=ec4b21d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4b21d6",
  null
  
)

export default component.exports